module.exports = __webpack_public_path__ + "static/media/TeamsAssets-Light.4521ef7e.woff";